import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box as Body, Button, DatePicker, Dialog, Icon } from '@node-space/ui-components'
import useFilterModal from 'components/FilterBar/hooks/useFilterModal'
import useFilterParams from 'components/FilterBar/hooks/useFilterParams'
import type { FilterModalType } from '../../types'
import FilterMerchant from '../Filters/FilterMerchant'
import FilterStatus from '../Filters/FilterStatus'
import FilterTag from '../Filters/FilterTag'

const FilterModal = ({
  eventHandlers,
  isChannel,
  filterDateRange,
  isChannelManagement,
}: FilterModalType) => {
  const { t } = useTranslation()

  const { isFilterModalOpen, toggleIsFilterModalOpen } = useFilterModal()
  const { filterCount } = useFilterParams()

  const onResetChanged = () => {
    eventHandlers?.onResetAll()
    toggleIsFilterModalOpen()
  }
  return (
    <>
      <Button
        testId="filter-modal-trigger-btn"
        variant="secondary"
        iconElement={<Icon name="Funnel" />}
        onClick={toggleIsFilterModalOpen}
      >
        {`${t('filters')} ${filterCount?.length ? `(${filterCount.length})` : ''}`}
      </Button>

      <Dialog
        title={t('filters')}
        open={isFilterModalOpen}
        onClose={toggleIsFilterModalOpen}
        type="utility"
        ActionButtons={[
          <Button
            key="show"
            testId="filter-modal-show-btn"
            onClick={() => {
              eventHandlers.showSearchResult()
              toggleIsFilterModalOpen()
            }}
          >
            {t('show')}
          </Button>,
          <Button
            key="resetAll"
            testId="filter-modal-reset-btn"
            variant="secondary"
            onClick={onResetChanged}
          >
            {t('resetAll')}
          </Button>,
        ]}
      >
        <Body testId="filter-modal-body" flexCol gapY={16}>
          {!isChannelManagement && (
            <DatePicker
              data-testid="filter-date-field"
              label={t('period')}
              placeholder={t('wallets.selectDate')}
              initialSelected={filterDateRange}
              onSelect={dateVal => {
                if (dateVal && eventHandlers?.onDateFilterChange) {
                  eventHandlers.onDateFilterChange(dateVal)
                }
              }}
            />
          )}
          <FilterMerchant onMerchantSelected={eventHandlers?.onMerchantSelected} />
          {!isChannelManagement && (
            <FilterStatus
              onPaymentStatusChanged={eventHandlers?.onPaymentStatusChanged}
              isChannel={isChannel}
            />
          )}
          {!isChannelManagement && (
            <FilterTag onPaymentTagChange={eventHandlers?.onPaymentTagChange} />
          )}
        </Body>
      </Dialog>
    </>
  )
}

export default FilterModal
